import React, { useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
  TableHead,
  Paper,
} from "@mui/material";
import BorderPdf from "../IconComp/borderPdf";
import AppButton from "../common/AppButton";
import { useReactToPrint } from "react-to-print";
import { useAppSelector } from "../../app/hooks";
import {
  salesHistoryTableHeaderData,
  stockHistoryTableHeaderData,
} from "../../utils/constants";

const StockHistorypdf = ({ tableRowData, handleClosePdf }: any) => {
  const componentRef = useRef<HTMLDivElement | null>(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const profiledata: any = useAppSelector(
    (state: any) => state.profile.profileDetails
  );
  // Add total row
  const totalQuantity = tableRowData.reduce(
    (sum: any, row: any) => sum + (row?.quantity || 0),
    0
  );
  const totalCostPrice = tableRowData.reduce(
    (sum: any, row: any) => sum + (row?.cost_price || 0),
    0
  );
  const totalDiscount = tableRowData.reduce(
    (sum: any, row: any) => sum + (row?.batch_discount || 0),
    0
  );
  const totalSalesTax = tableRowData.reduce(
    (sum: any, row: any) => sum + (row?.tax_amount || 0),
    0
  );
  const totalAmount = tableRowData.reduce(
    (sum: any, row: any) =>
      sum +
      (row?.cost_price && row?.quantity ? row.cost_price * row.quantity : 0),
    0
  );

  return (
    <>
      <Box
        ref={componentRef}
        sx={{
          width: "100%",
          px: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <Box sx={{ fontWeight: "600", fontSize: "18px", mt: 3 }}>
            {profiledata?.pharmacy?.name}
          </Box>
          <Box sx={{ fontWeight: "400", fontSize: "14px" }}>
            {profiledata?.pharmacy?.address?.address}
          </Box>
        </Box>
        {/* border */}
        <Box
          sx={{
            mt: 4,
            borderTop: "6px double #c6c6c6",
          }}
        >
          {/* <BorderPdf /> */}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "14px",
            fontWeight: "400",
            color: "#000000",
            mt: 3,
            px: 2,
          }}
        >
          <Box>INVOICE</Box>
          <Box>
            {tableRowData[0]?.batch_purchase_date
              ? new Date(
                  tableRowData[0].batch_purchase_date
                ).toLocaleDateString("en-GB")
              : "-"}
          </Box>
        </Box>
        {/* table */}
        <Box sx={{ mt: 3 }}>
          <TableContainer>
            <Table>
              <TableHead
                sx={{ bgcolor: "#F0F0F0", borderBottom: "1px solid #000000" }}
              >
                <TableRow>
                  {stockHistoryTableHeaderData.map((header, index) => (
                    <TableCell
                      key={index}
                      //   align="center"
                      sx={{
                        fontWeight: 500,
                        borderBottom: "1px solid #DDDDDD",
                      }}
                    >
                      {header.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {tableRowData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={stockHistoryTableHeaderData.length}>
                      <Box
                        sx={{
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100px", // Adjust height as needed
                        }}
                      >
                        No Data Found!
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {tableRowData.map((row: any, rowIndex: number) => (
                    <TableRow key={rowIndex}>
                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.stock_inv_no || "-"}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.supplier?.supplier_company_name || "-"}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.pharmacy_medicine?.name || "-"}
                      </TableCell>

                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.quantity || "-"}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.cost_price ? `Rs.${row?.cost_price}` : "-"}
                      </TableCell>

                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.batch_discount
                          ? `Rs.${row?.batch_discount}`
                          : "-"}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.tax_amount ? `Rs.${row?.tax_amount}` : "-"}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #DDDDDD" }}>
                        {row?.quantity * row?.cost_price
                          ? `Rs.${row?.quantity * row?.cost_price}`
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* show totals of all amounts */}

                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
                    <TableCell colSpan={2} />
                    <TableCell sx={{ fontWeight: "bold" }}>
                      {totalQuantity}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Rs.{totalCostPrice}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Rs.{totalDiscount}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Rs.{totalSalesTax}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Rs.{totalAmount}
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Box>

        {/* Footer */}
        {/* <Box sx={{ mt: 3, textAlign: "right", px: 3 }}>
          <Typography variant="subtitle1">
            <strong>Total Sales:</strong> Rs. {totalAmount.toFixed(2)}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Total Cost:</strong> Rs. {totalCost.toFixed(2)}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Total Discount:</strong> Rs. {totalDiscount.toFixed(2)}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Net Revenue:</strong> Rs. {totalProfit.toFixed(2)}
          </Typography>
        </Box> */}

        {/* Footer Note */}
        <Box
          sx={{
            mt: 2,
            textAlign: "center",
            borderTop: "1px solid #DDDDDD",
            p: 2,
            fontSize: "12px",
          }}
        >
          Software By E-Mareez Care, Phone# 03095558054
        </Box>
      </Box>
      <Box sx={{ textAlign: "center", pb: 1 }} className="no-print">
        <AppButton
          variant="contained"
          color="primary"
          title="Print"
          sx={{ backgroundColor: "#01A768" }}
          onClick={() => {
            handlePrint();
            handleClosePdf();
          }}
        />
      </Box>
    </>
  );
};

export default StockHistorypdf;
